import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title text-fprimary fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-image fs-1 me-4 text-fprimary" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-4" }
const _hoisted_9 = { class: "d-flex mt-4 justify-content-center gap-6" }
const _hoisted_10 = { class: "d-flex flex-column align-items-center gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "bi bi-check fs-2x text-white"
}
const _hoisted_12 = { class: "fs-7 fw-bold" }
const _hoisted_13 = { class: "d-flex flex-column align-items-center gap-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload fs-4 text-white" }, null, -1)
const _hoisted_15 = { class: "fs-7 fw-bold" }
const _hoisted_16 = { class: "d-flex flex-column align-items-center gap-2" }
const _hoisted_17 = { class: "fs-7 fw-bold" }
const _hoisted_18 = { class: "d-flex flex-column align-items-center gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "bi bi-magic fs-2 text-white"
}
const _hoisted_20 = { class: "fs-7 fw-bold" }
const _hoisted_21 = { class: "col-sm-7" }
const _hoisted_22 = {
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_23 = { class: "alert-heading" }
const _hoisted_24 = { class: "fw-normal my-6" }
const _hoisted_25 = {
  key: 0,
  class: "badge badge-light-success border border-success"
}
const _hoisted_26 = {
  key: 1,
  class: "badge badge-light-danger border border-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_btnDownload = _resolveComponent("btnDownload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_UploadFileModal = _resolveComponent("UploadFileModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.t('photography')), 1)
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createVNode(_component_el_avatar, {
              size: 100,
              shape: "square",
              class: "w-100 h-400px",
              fit: 'fit',
              src: `${_ctx.urlServerFile}/${_ctx.photo.ruta}`
            }, null, 8, ["src"]), [
              [_directive_loading, _ctx.loader]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_button, {
                  size: "large",
                  circle: "",
                  color: "#626aef",
                  loading: _ctx.loader,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPhoto(_ctx.idacrd, _ctx.photo?.idphoto)))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.loader)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('select')), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_button, {
                  size: "large",
                  circle: "",
                  color: "#626aef",
                  onClick: _ctx.onDialogPhoto
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t('upload')), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.photo.ruta)
                  ? (_openBlock(), _createBlock(_component_btnDownload, {
                      key: 0,
                      resource: _ctx.photo.ruta,
                      "name-file": _ctx.photo?.idphoto
                    }, null, 8, ["resource", "name-file"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_button, {
                  size: "large",
                  circle: "",
                  color: "#626aef",
                  loading: _ctx.loader,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeBg(_ctx.photo?.idphoto)))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.loader)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t('removebackground')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.t('recommendations')), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.t('photo1')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.t('photo2')), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.t('photo3')), 1)
              ])
            ]),
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.t('photoHistory')), 1),
            _createVNode(_component_el_table, {
              data: _ctx.photoList,
              style: {"width":"100%"},
              "max-height": "250",
              "table-layout": 'auto',
              border: "",
              "highlight-current-row": "",
              onCurrentChange: _ctx.handleCurrentChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "idphoto",
                  width: "70",
                  label: "ID",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "ruta",
                  label: "RUTA",
                  width: "auto"
                }),
                _createVNode(_component_el_table_column, {
                  label: "ESTADO",
                  width: "110"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.mstatus == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Activo"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, "Archivado"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "onCurrentChange"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_UploadFileModal, {
      ref: "uploadPhotoRef",
      extens: '.png, .jpg, jpeg',
      maxFileSizeMB: 1,
      "params-upload": _ctx.paramsUpload,
      allowedMIMEs: ['image/png', 'image/jpg', 'image/jpeg'],
      onUploadResponse: _ctx.uploadResponse
    }, null, 8, ["extens", "params-upload", "onUploadResponse"])
  ], 64))
}